const PLAYSTORE_URL = 'https://play.google.com/store/apps/details?id=io.zutun.sae';

export { PLAYSTORE_URL };
